<template>
  <validation-observer
    ref="connectForm"
    #default="{ invalid }"
  >
    <b-form @submit.prevent="onSubmit">
      <b-row>
        <b-col cols="12">
          <b-form-group
            :label="$t('Mobile')"
            label-for="login-mobile"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Mobile')"
              vid="mobile"
              rules="required"
            >
              <vue-phone-number-input
                v-model="fullMobile"
                style="direction:ltr"
                default-country-code="IR"
                name="mobile"
                :disabled="step !== 1"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('Mobile')"
                :translations="{
                  countrySelectorLabel: $t('Country Code'),
                  countrySelectorError: $t('Choose a country'),
                  phoneNumberLabel: $t('Mobile'),
                  example: $t('Example')+' :'
                }"
                :dark="$store.state.appConfig.layout.skin === 'dark'"
                dark-color="#283046"
                @update="updateMobil"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            v-if="step > 1"
            :label="$t('Verify code')"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('verify code')"
              vid="verify_code"
              rules="required"
            >
              <b-form-input
                id="verify_code"
                v-model="form.verify_code"
                type="text"
                :disabled="step !== 2"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('Verify code')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <!-- password -->
          <b-form-group
            v-if="step === 3"
            label-for="password"
            :label="$t('Password')"
          >
            <validation-provider
              #default="{ errors }"
              name="password"
              vid="password"
              rules="required"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="register-password"
                  v-model="form.password"
                  class="form-control-merge"
                  :type="passwordFieldType"
                  :state="errors.length > 0 ? false : null"
                  name="password"
                  :placeholder="hint"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIcon"
                    class="cursor-pointer"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- submit -->
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            :disabled="spin || invalid"
          >
            <b-spinner
              v-if="spin"
              small
            />
            {{ $t("Connect account") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
  name: 'AccountVerifyCodeConnector',
  components: {
    BRow,
    BCol,
    BButton,
    BSpinner,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  props: {
    account: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      step: 1,
      form: {
        mobile: '',
        verify_code: '',
        password: '',
      },
      hint: '············',
      fullMobile: '',
      spin: false,
      required,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    updateMobil(e) {
      this.validMobile = e.isValid
      if (e.isValid) {
        this.form.mobile = e.e164
        this.fullMobile = e.formatInternational
      }
    },
    onSubmit() {
      this.$refs.connectForm.validate().then(success => {
        if (success) {
          // set spinner to submit button
          this.spin = true
          // send connect request
          if (this.validMobile) {
            this.$http.post(`accounts/${this.account.id}/verify-code-connect`, this.form).then(({ data }) => {
              if (data.step === 'error') {
                this.spin = false
                this.step = 1
                this.showErrorNotification(data.error)
              } else if (data.step !== 'success') {
                this.spin = false
                if (data.hint) {
                  this.hint = data.hint
                }
                if (data.step === 'waitCode') {
                  this.step = 2
                } else if (data.step === 'waitPassword') {
                  this.step = 3
                }
              } else {
                this.$emit('onAccountConnected')
              }
            }).catch(() => {
              this.spin = false
            })
          } else {
            this.spin = false
            this.showErrorNotification(this.$t('check form data'))
          }
        }
      })
    },
  },
}
</script>
<style scoped>

</style>
